module.exports = __webpack_public_path__ + "static/media/github-octocat.d617763f.svg";